import usePrivateAxios from "@/common/api/usePrivateAxios"
import { ReasonValidationSchema } from "@/common/schemas/reason.schema"
import { useMutation } from "@tanstack/react-query"

interface UseArchivePublicCompanyProps {
  publicCompanyLeadId?: string
  onSuccess?: () => void
  onError?: () => void
}

export const useArchivePublicCompanyLead = ({
  publicCompanyLeadId,
  onSuccess,
  onError,
}: UseArchivePublicCompanyProps) => {
  const privateAxios = usePrivateAxios()
  return useMutation({
    mutationKey: ['archivePublicCompany'],
    mutationFn: async ({ log_reason, newStatus }: { log_reason: ReasonValidationSchema, newStatus: string }) => {
      await privateAxios.put(`/funnel/public/leads/${publicCompanyLeadId}/${newStatus}`, { log_reason })
    },
    onSuccess,
    onError,
  })
}
